var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('top-navbar'),_c('div',{staticClass:"container-fluid mb-5"},[_vm._v("\r\n          Calender\r\n        ")]),_c('content-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }